import { Component, Input, OnInit } from '@angular/core';
import { PreferenceService } from '../../shared/services/preference.service';

@Component({
    selector: 'kx-voice-search',
    templateUrl: './voice-search.component.html',
    styleUrls: ['./voice-search.component.scss'],
    standalone: false
})
export class VoiceSearchComponent implements OnInit {
  selectedVoice: boolean = true;

  constructor(
    private preference: PreferenceService
  ) { }

  ngOnInit(): void {
   this.selectedVoice = this.preference.checkCommonConfigEnabled("voice_search")
  }

  changeVoiceEnable(event: any): void {
    this.selectedVoice = JSON.parse(event.target.value);
    this.preference._saveCommonVoiceDetailsConfig('voice_search', this.selectedVoice, ()=> {
      window.location.reload();
    });
  }
}